import { api } from '@/lib/trpc/react';
import { parseAsString, useQueryState } from 'nuqs';
import { useEffect, useRef } from 'react';
import { useWorkspaceActions } from './useWorkspace';

const useCopyChatbot = () => {
  const [chatbotId] = useQueryState('chatbotId', parseAsString);
  const isCopyingRef = useRef(false);

  const { addChatbot } = useWorkspaceActions();
  const { mutateAsync: copyChat } = api.publicChat.copyChat.useMutation({
    retry: 2,
    onSuccess: (data) => {
      addChatbot({
        ...data,
        isIndexed: data.isIndexed,
        ingestionStatus: data.ingestionStatus?.status,
        authors: data.authors as string[],
      });
    },
  });

  useEffect(() => {
    if (chatbotId && !isCopyingRef.current) {
      isCopyingRef.current = true;
      copyChat(chatbotId);
    }
  }, [chatbotId, copyChat]);
};

export default useCopyChatbot;
